import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=317b8854&scoped=true"
import script from "./GeneralInfo.vue?vue&type=script&lang=js"
export * from "./GeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfo.vue?vue&type=style&index=0&id=317b8854&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317b8854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('317b8854')) {
      api.createRecord('317b8854', component.options)
    } else {
      api.reload('317b8854', component.options)
    }
    module.hot.accept("./GeneralInfo.vue?vue&type=template&id=317b8854&scoped=true", function () {
      api.rerender('317b8854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/umesr/components/GeneralInfo.vue"
export default component.exports